module.exports = __webpack_public_path__ + "arrow_gold_right.png?f0c02ffedd01e1082eb988aec9646ebb";


//////////////////
// WEBPACK FOOTER
// ./assets/img/arrow_gold_right.png
// module id = 38
// module chunks = 0